import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stripeCheckout } from "../../../../api/purchases";
import { alertError } from "../../../../utils";

export function PaymentSuccessPage() {
  const Tick = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{
          backgroundColor: 'transparent',
          border: '2px solid green',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 60,
          height: 60,
          borderRadius: 30,
        }}>
          <p style={{ color: 'green', fontSize: 24, margin: 0 }}>✓</p>
        </div>
      </div>
    )
  }

  return (
    <>
    <div className='success-page' style={{ textAlign: 'center', padding: '50px' }}>
      <Tick />
      <br/><br/>
      <h2>Muchas gracias!</h2>
      <br />
      <p>Pago realizado satisfactóriamente.</p>
      <br /><br/><br/><br /><br/><br/><br /><br/><br/>
    </div>
    </>
  );
}
